import React, {useMemo} from "react";
import styles from './index.module.scss'

function ProjectCheckmark() {
    return (
        <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <rect x="2" y="2" width="20" height="20" rx="4.44444" fill="#453CFB"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M17.3875 8.6972C17.7731 9.04867 17.7731 9.61852 17.3875 9.96999L11.4832 15.3516C11.0594 15.7378 10.3725 15.7378 9.94877 15.3516L6.43374 12.1478C6.04813 11.7963 6.04813 11.2264 6.43374 10.875C6.81936 10.5235 7.44456 10.5235 7.83018 10.875L10.716 13.5052L15.9911 8.6972C16.3767 8.34573 17.0019 8.34573 17.3875 8.6972Z" fill="white"/>
        </svg>
    )
}


const ProjectList = ({projects = [], setActiveProjects, activeProjects, setActiveUser}: any) => {
    const checkedAll = useMemo(() => projects.length > 0 && projects.length === activeProjects.length, [projects.length, activeProjects.length]);

    const checkAllHandler = () => {
        if(checkedAll){
            setActiveProjects([])
            return;
        }

        setActiveProjects(projects.map((project: any) => project?.id))
        setActiveUser(null)
    }

    return (
        <div className={styles.projectList}>
            <div className={styles.projectList__title}>
                <div className={styles.projectList__titleText}>Проекты</div>
                <button
                    type="button"
                    className={`${styles.projectList__checkbox} ${checkedAll ? styles.checked : ''}`}
                    onClick={checkAllHandler}
                    aria-label={checkedAll ? 'Снять выбор со всех проектов' : 'Выбрать все проекты'}
                    aria-pressed={checkedAll}
                >
                    <ProjectCheckmark/>
                </button>
            </div>
            <div className={styles.projectList__users}>
                {projects.map((project: any) => {
                    const isActive = activeProjects.includes(project?.id);

                    const changeActive = () => {
                        if(isActive){
                            setActiveProjects(activeProjects.filter((projectId: any) => projectId !== project?.id))
                            setActiveUser(null)
                            return
                        }

                        setActiveProjects([...activeProjects, project?.id, ])
                        setActiveUser(null)
                    }

                    return (
                        <button
                            key={String(project.id)}
                            type="button"
                            className={`${styles.projectList__user} ${isActive ? styles.active : ''}`}
                            onClick={changeActive}
                            aria-pressed={isActive}
                        >
                            <div className={styles.projectList__user_title}>
                                {project.name}
                            </div>
                            <span className={`${styles.projectList__checkbox} ${isActive ? styles.checked : ''}`} aria-hidden="true">
                                <ProjectCheckmark/>
                            </span>
                        </button>
                    )
                })}
            </div>
        </div>
    )
}

export default ProjectList;
